import { createReducer } from '@reduxjs/toolkit';
import t from '@/store/types';

const initialState: {
  views: Record<string, any>;
  resourceViews: Record<string, any[]>;
  viewsMeta: Record<string, any>;
} = {
  views: {},
  resourceViews: {
    accounts: [],
    expenses: [],
  },
  viewsMeta: {},
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.VIEW_META_SET, (state, action: any) => {
    state.viewsMeta[action.view.id] = action.view;
  });

  builder.addCase(t.RESOURCE_VIEWS_SET, (state, action: any) => {
    state.resourceViews[action.resource] = action.views.map((v: any) => v.id);
  });

  builder.addCase(t.VIEW_ITEMS_SET, (state, action: any) => {
    const _views: Record<string, any> = {};

    action.views.forEach((view: any) => {
      _views[view.id] = view;
    });
    state.views = { ...state.views, ..._views };
  });
});
